module.exports = __webpack_public_path__ + "img/avatar7.ceec891c.png";